import { RouteGroup } from '@Constants/routes';
import React from 'react';
import PromoCodes from '../PromoCodes';
import PromoCodeForm from '../components/PromoCodeForm';
import { UpdatePromoCode } from '../Pages/UpdatePromoCode/UpdatePromoCode';
import { UsageTable } from '../components/UsageTable/UsageTable';

export const PromoCodesRoute: RouteGroup = {
	isRouted: true,
	title: 'Promo Codes',
	route: 'promo-codes',
	icon: 'local_offer',
	code: 'promocode',
	component: <PromoCodes />,
	routes: [
		{
			route: 'create',
			component: <PromoCodeForm />,
			title: '',
			code: '',
			offMenu: true,
		},
		{
			route: 'update/:id',
			component: <UpdatePromoCode />,
			title: '',
			code: '',
			offMenu: true,
		},
		{
			route: 'usage/:id',
			component: <UsageTable />,
			title: '',
			code: '',
			offMenu: true,
		},
	],
};
